import React, { useRef } from 'react';
import { useLanguage } from '../App';
import { motion } from 'framer-motion';
import { Download, Share2 } from 'lucide-react';

export default function CertificatePage() {
  const { language } = useLanguage();
  const isEN = language === 'en';
  const certRef = useRef();

  // Get data from URL params
  const params = new URLSearchParams(window.location.search);
  const name = params.get('name') || 'Student';
  const subject = params.get('subject') || 'Mathematics';
  const score = params.get('score') || '100';
  const date = params.get('date') || new Date().toLocaleDateString();

  const downloadCert = async () => {
    const { default: html2canvas } = await import('html2canvas');
    const canvas = await html2canvas(certRef.current, { scale: 2, backgroundColor: '#ffffff' });
    const link = document.createElement('a');
    link.download = `PANTASS_Certificate_${name}.png`;
    link.href = canvas.toDataURL();
    link.click();
  };

  const shareCert = () => {
    const msg = isEN
      ? `${name} scored ${score} points in ${subject} on PANTASS! Try it: https://pantass.com`
      : `${name} dapat ${score} markah dalam ${subject} di PANTASS! Cuba: https://pantass.com`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <div className="certificate-page">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}>
        <div className="certificate-card" ref={certRef}>
          <div className="cert-border">
            <div className="cert-inner">
              <div className="cert-logo">
                <img src="/pantass-logo.jpg" alt="PANTASS" style={{ width: 40, height: 40, borderRadius: 10 }} />
                <span>PANTASS</span>
              </div>
              <div className="cert-trophy">&#127942;</div>
              <h1 className="cert-title">{isEN ? 'Certificate of Achievement' : 'Sijil Pencapaian'}</h1>
              <p className="cert-subtitle">{isEN ? 'This is to certify that' : 'Ini adalah untuk mengesahkan bahawa'}</p>
              <h2 className="cert-name">{name}</h2>
              <p className="cert-achievement">
                {isEN
                  ? `has demonstrated excellence in ${subject} with a score of ${score} points`
                  : `telah menunjukkan kecemerlangan dalam ${subject} dengan skor ${score} markah`}
              </p>
              <div className="cert-date">{date}</div>
              <div className="cert-footer">
                <div className="cert-line"></div>
                <p>PANTASS Education</p>
              </div>
            </div>
          </div>
        </div>

        <div className="cert-actions">
          <button className="cert-btn cert-btn-download" onClick={downloadCert}><Download size={18} /> {isEN ? 'Download' : 'Muat Turun'}</button>
          <button className="cert-btn cert-btn-share" onClick={shareCert}><Share2 size={18} /> {isEN ? 'Share WhatsApp' : 'Kongsi WhatsApp'}</button>
        </div>
        <button className="setup-back-btn" onClick={() => window.history.back()} style={{ marginTop: '12px' }}>&larr; {isEN ? 'Back' : 'Kembali'}</button>
      </motion.div>
    </div>
  );
}
